<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>이벤트 관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          마켓팅 관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/marketing/EventManagement">이벤트 관리</a>
        </li>
      </ol>
    </div>
    <!-- 검색  -->
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="기간" :data="data" @search="search" @reset="reset" />
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">목록</span>
        <div class="card-tool float-right" >
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="saveDetail()" >등록</b-btn>
        </div>
        <ShowCounter label="Show" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td style="text-align:center">No</td>
              <td style="text-align:center">썸네일</td>
              <td style="text-align:center" @click="localSort.sort('title')">이벤트명<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('announceYn')">당첨자발표<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center">기간</td>
              <td style="text-align:center" @click="localSort.sort('regId')">등록자ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('regDt')">등록일시<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>
          </thead>

          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
            <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index"  > <!--  @click.prevent="edit(item.seq);" -->
              <td class="align-middle text-center" @click="edit(item.seq)">{{data.params.limit*(data.params.page-1) + index+1}}</td>
              <td class="align-middle text-center"  style="width: 194px;height: 75px;padding: 5px;" @click="edit(item.seq)"><img  style="width: auto;height: 100%;" :src="item.thumbnailUrl"/></td>
              <td class="align-middle text-center" @click="edit(item.seq)">{{item.title}}</td>
              <td class="align-middle text-center" @click="edit(item.seq)">{{item.announceYn =='Y' ? '발표완료' : '미발표'}}</td>
              <td class="align-middle text-center" @click="edit(item.seq)">{{item.startDt != null ? item.startDt.substr(0,16) : ''}} - {{item.endDt != null ? item.endDt.substr(0,16) : ''}}</td>
              <td class="align-middle text-center" @click="edit(item.seq)">{{item.regId}}</td>
              <td class="align-middle text-center" @click="edit(item.seq)">{{item.regDt != null ? item.regDt.substr(0,10) : ''}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <!-- 상세 -->
    <div v-show="data.params.mode=='detail'" class="card card-default book-list">
      <div class="card-body" style="background-color:#fff;">
          <table class="table table-bordered table-hover">
            <tbody>
                <tr>
                    <td class="align-middle text-center">이벤트 ID</td>
                    <td class="align-middle text-center" colspan="3">
                        <input type="text" v-model="data.row.seq" :class="{'not-text form-control':true, 'is-invalid': errors.has('seq')}"  v-validate="''"  name="seq" style="width: 100%"  />
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">이벤트 명</td>
                    <td class="align-middle text-center" colspan="3">
                        <input type="text" v-model="data.row.title" :class="{' form-control':true, 'is-invalid': errors.has('title')}"  v-validate="'required|min:2'"  name="title" style="width: 100%"  />
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">이벤트 설명</td>
                    <td class="align-middle text-center" colspan="3">
                        <input type="text" v-model="data.row.description" :class="{' form-control':true, 'is-invalid': errors.has('description')}"  v-validate="'required|min:2'"  name="description" style="width: 100%"  />
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">내용</td>
                    <td class="align-middle text-left" colspan="3">
                       <!-- <quill-editor
                            ref="myQuillEditor"
                            v-model="data.row.content"
                            :style="'min-height:300px'"
                        /> -->
                        <jodit-editor
                          v-model="data.row.content"
                          :config="jodit_config.config"
                          :buttons="jodit_config.buttons"
                          :plugins="jodit_config.plugins"
                          :class="{'is-invalid': errors.has('content')}"
                          v-validate="'required|min:2'"
                          name="content"
                          :style="'min-height:300px;'"
                        />
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">썸네일 등록<br>(540*200)</td>
                    <td class="align-middle" colspan="3">
                        <div class="custom-file">
                          <div v-show="data.row.thumbnailUrl == null && uploadImageFile == null">
                            <input type="file" class="display-file" accept="image/*" id="file" @change="insertFileName">
                            <label class="custom-file-label" for="file">Choose a file...</label>
                          </div>
                          <div style="width: max-content;position: relative;">
                            <a class="popupImageItem" v-show="uploadImageFile != null && uploadImageFileValue != null" :href="uploadImageFile" style="width:100%;padding-top:0" target="_blank" download>{{fileName}}</a>
                            <a class="popupImageItem" v-show="uploadImageFile != null && uploadImageFileValue == null" @click="downloadAs()" style="width:100%;padding-top:0" target="_blank">{{fileName}}</a>
                            <span class="btn_remove" @click="fileRemove()" >X</span>
                          </div>
                        </div>
                    </td>
                </tr>
                <tr >
                    <td class="align-middle text-center">시작일</td>
                    <td class="align-middle d-flex align-items-center" style="border:none;">
                        <!-- <datepicker
                            v-model="data.row.startDt"
                            v-validate="'required'"
                            name="startDt"
                            :class="{'is-invalid': errors.has('startDt')}"
                            :bootstrapStyling="true"
                            :monday-first="true"
                            :full-month-name="true"
                            placeholder="Select date"
                            :calendar-button="true"
                            calendar-button-icon="far fa-calendar"
                            :clear-button="true"
                            :style="'width:calc(100% - 80px);'" /> -->
                        <datetimepicker
                            ref="datetime_startDt"
                            v-model="data.row.startDt"
                            v-validate="'required'"
                            name="startDt"
                            :class="{'is-invalid': errors.has('startDt')}"
                            format="YYYY-MM-DD H:i"
                            :style="'width:calc(100% - 80px);'" />
                        <input type="checkbox" v-model="Datedata.startDtChk" class="ml-2" @change="changeDate('now')">
                        <label class="form-check-label ml-1 ">즉시</label>
                    </td>
                    <td class="align-middle text-center">종료일</td>
                    <td class="align-middle d-flex align-items-center" style="border:none;">
                        <!-- <datepicker
                            v-model="data.row.endDt"
                            v-validate="'required'"
                            name="endDt"
                            :class="{'is-invalid': errors.has('endDt')}"
                            :bootstrapStyling="true"
                            :monday-first="true"
                            :full-month-name="true"
                            placeholder="Select date"
                            :calendar-button="true"
                            calendar-button-icon="far fa-calendar"
                            :clear-button="true"
                            :style="'width:calc(100% - 80px);'"/> -->
                        <datetimepicker
                            ref="datetime_endDt"
                            v-model="data.row.endDt"
                            v-validate="'required'"
                            name="endDt"
                            :class="{'is-invalid': errors.has('endDt')}"
                            :bootstrapStyling="true"
                            placeholder="Select date"
                            format="YYYY-MM-DD H:i"
                            :style="'width:calc(100% - 80px);'"/>
                        <input type="checkbox" v-model="Datedata.endDtChk" class="ml-2" @change="changeDate('end')">
                        <label class="form-check-label ml-1">영구</label>
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">댓글가능 여부</td>
                    <td class="align-middle">
                        <b-form-select :options="searchOptionsYn" v-model="data.row.replyYn" name="CatKind" class="custom-select custom-select-sm" style="width:max-content"></b-form-select>
                    </td>
                    <td class="align-middle text-center">댓글파일첨부</td>
                    <td class="align-middle">
                        <b-form-select :options="searchOptionsYn" v-model="data.row.replyAttachYn" name="CatKind" class="custom-select custom-select-sm" style="width:max-content"></b-form-select>
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">열람허용 회원유형</td>
                    <td class="align-middle" colspan="3">
                        <input type="checkbox" class="ml-1" v-model="data.row.readingTeacherUseYn" true-value="Y" false-value="N" >
                        <label class="form-check-label ml-1">학교교사</label>
                        <input type="checkbox" class="ml-2" v-model="data.row.readingTutorUseYn" true-value="Y" false-value="N" >
                        <label class="form-check-label ml-1">학원강사</label>
                        <input type="checkbox" class="ml-2" v-model="data.row.readingStudentUseYn" true-value="Y" false-value="N" >
                        <label class="form-check-label ml-1">학생</label>
                        <input type="checkbox" class="ml-2" v-model="data.row.readingParentsUseYn" true-value="Y" false-value="N" >
                        <label class="form-check-label ml-1">학부모</label>
                    </td>
                </tr>
                 <tr >
                    <td class="align-middle text-center">댓글허용 회원유형</td>
                    <td class="align-middle" colspan="3">
                        <input type="checkbox" class="ml-1" v-model="data.row.replyTeacherUseYn" true-value="Y" false-value="N" >
                        <label class="form-check-label ml-1">학교교사</label>
                        <input type="checkbox" class="ml-2" v-model="data.row.replyTutorUseYn" true-value="Y" false-value="N" >
                        <label class="form-check-label ml-1">학원강사</label>
                        <input type="checkbox" class="ml-2" v-model="data.row.replyStudentUseYn" true-value="Y" false-value="N" >
                        <label class="form-check-label ml-1">학생</label>
                        <input type="checkbox" class="ml-2" v-model="data.row.replyParentsUseYn" true-value="Y" false-value="N" >
                        <label class="form-check-label ml-1">학부모</label>
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">등록자 ID</td>
                    <td class="align-middle">
                        <input type="text" v-model="data.row.regAdminId" :class="{'not-text form-control':true, 'is-invalid': errors.has('regAdminId')}"  v-validate="''"  name="regAdminId" style="width: 100%"  />
                    </td>
                    <td class="align-middle text-center">등록일시</td>
                    <td class="align-middle ">
                         <input type="text" v-model="data.row.regDt" :class="{'not-text form-control':true, 'is-invalid': errors.has('regDt')}"  v-validate="''"  name="regDt" style="width: 100%"  />
                    </td>
                </tr>
                 <tr>
                    <td class="align-middle text-center">수정자 ID</td>
                    <td class="align-middle">
                        <input type="text" v-model="data.row.updAdminId" :class="{'not-text form-control':true, 'is-invalid': errors.has('updAdminId')}"  v-validate="''"  name="updAdminId" style="width: 100%"  />
                    </td>
                    <td class="align-middle text-center">수정일시</td>
                    <td class="align-middle ">
                         <input type="text" v-model="data.row.updDt" :class="{'not-text form-control':true, 'is-invalid': errors.has('updDt')}"  v-validate="''"  name="updDt" style="width: 100%"  />
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="card-tool float-left mt-3">
          <b-btn class="btn btn-xs btn-outline-info mr-2" v-show="data.row.seq != null" variant="outline-primary" style="width:100px;" @click="showBottom(BottomType.ReplyNotice, true);" >댓글공지</b-btn>
          <b-btn class="btn btn-xs btn-outline-info mr-2" v-show="data.row.seq != null" variant="outline-primary" style="width:100px;" @click="showBottom(BottomType.AnnNotice, true);" >당첨자발표</b-btn>
        </div>
        <div class="footer mt-3">
          <div class="float-right">
              <b-button @click="bottomType=BottomType.None;search()" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
              <b-button @click="save(BottomType.None)" class="btn btn-b btn-info mr-2" variant="info mr-2">{{data.row.seq == null ? '저장' : '수정'}}</b-button>
              <b-button v-show="!!data.row.seq" @click="remove(BottomType.None)" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">삭제</b-button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="bottomType==BottomType.ReplyNotice" class="card card-default book-list">
      <div class="card-body" style="background-color:#fff;">
        <table class="table table-bordered table-hover">
            <tbody>
                <tr>
                    <td class="align-middle text-center" width="10%">댓글 공지</td>
                    <td class="align-middle text-center" colspan="3">
                      <input type="text" v-model="data.row.replyNotice" :class="{'form-control':true, 'is-invalid': errors.has('replyNotice')}"
                        v-validate="''" name="replyNotice" style="width: 100%" />
                    </td>
                </tr>
            </tbody>
        </table>
      </div>
      <div class="footer mb-3 mr-1">
        <div class="float-right">
          <b-button @click="save(BottomType.ReplyNotice)" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">{{data.row.replySeq ? '수정' : '등록'}}</b-button>
          <b-button @click="showBottom(BottomType.None)" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">닫기</b-button>
          <b-button v-show="data.row.replySeq" @click="remove(BottomType.ReplyNotice)" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">삭제</b-button>
        </div>
      </div>
    </div>
    <div v-show="bottomType==BottomType.AnnNotice" class="card card-default book-list">
      <div class="card-body" style="background-color:#fff;">
        <table class="table table-bordered table-hover">
            <tbody>
              <tr>
                  <td class="align-middle text-center" width="10%" rowspan="2">당첨자 발표</td>
                  <td class="align-middle text-center" width="10%">발표일</td>
                  <td>
                      <!-- <datepicker
                        v-model="data.row.announceDt"
                        :bootstrapStyling="true"
                        :monday-first="true"
                        :full-month-name="true"
                        placeholder="Select date"
                        :calendar-button="true"
                        calendar-button-icon="far fa-calendar"
                        :clear-button="true"
                        :style="'width:200px'"/> -->
                      <datetimepicker
                        ref="datetime_announceDt"
                        v-model="data.row.announceDt"
                        format="YYYY-MM-DD H:i"
                        :style="'width:200px'"/>
                  </td>
                </tr>
                <tr>
                    <td class="align-middle text-left sm-editor" colspan="3">
                        <!-- <quill-editor
                            ref="myQuillEditor"
                            v-model="data.row.announceContent"
                        /> -->
                        <jodit-editor
                          v-model="data.row.announceContent"
                          :config="jodit_config.config"
                          :buttons="jodit_config.buttons"
                          :plugins="jodit_config.plugins"
                          :style="'min-height:300px;'"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
      </div>
      <div class="footer mb-3 mr-1">
        <div class="float-right">
          <b-button @click="save(BottomType.AnnNotice)" class="btn btn-b btn-info mr-2" variant="info mr-2">{{data.row.announceYn == 'Y' ? '수정' : '등록'}}</b-button>
          <b-button @click="showBottom(BottomType.None)" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">닫기</b-button>
          <b-button v-show="data.row.announceYn=='Y'" @click="remove(BottomType.AnnNotice)" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">삭제</b-button>
        </div>
      </div>
    </div>
  </ContentWrapper>
</template>
<style scoped>
  /* .quill-editor.is-invalid, .vdp-datepicker.is-invalid { */
  .is-invalid {
    border:1px solid #f05050
  }
</style>
<script>
import Vue from 'vue'
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount, nextTick} from '@vue/composition-api'
import {dataObject} from "@/utils/Constants";
import {getEventList,getEventDetail,saveEvent,deleteEvent,saveEventPrize,deleteEventPrize, saveReplyNotice, deleteReplyNotice} from "@/api/marketing/EventAPI";
import {getSsoAdmList} from "@/api/sso/SsoAdmApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import Keyword from "../../components/Common/Keyword";
// import Datepicker from 'vuejs-datepicker'
import Datetimepicker from 'vuejs-datetimepicker'
import swal from 'sweetalert2'
import Axios from 'axios';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import draggable from 'vuedraggable'
// 목차/차시/파일

// import VueQuillEditor from 'vue-quill-editor'

// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme
import vueMoment from 'vue-moment' 

// jodit Editor
import 'jodit/build/jodit.min.css'
import { JoditEditor } from 'jodit-vue'
import { jodit_config } from '@/components/Common/jodit_config'

Vue.use(vueMoment)
// Vue.use(VueQuillEditor, /* { default global options } */)

export default {
  components: {SchDateRange, SchText, ShowCounter, Pagenation,  Loading, draggable, Keyword, Datetimepicker, JoditEditor},

  setup(props, {root}){
    const selectedContSeq = '';

    const uploadImageFileValue = ref();
    const uploadImageFile = ref(null);

    const BottomType = reactive({
      None:'',
      ReplyNotice:'replyNotice',
      AnnNotice: 'announceWinner'
    })
    const bottomType = ref(BottomType.None);

    const searchOptionsYn = ref([
      {text: 'Y', value:'Y'},
      {text: 'N', value:'N'},
    ]);
    const searchOptions = ref([]);
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject)

    const fileName = ref('');

    const searchText = ref('');
    const searchValue = ref([]);
    const searchShowValue = ref([]);

    const datetime_startDt = ref(null);
    const datetime_endDt = ref(null);
    const datetime_announceDt = ref(null);

    const Datedata = reactive({
      startDt: moment().format("yyyy-MM-DD HH:mm"),
      startDtChk : false,
      endDt: '9998-12-31 23:59:59',
      endDtChk : false,
    })
    
    const loadData = async () => {
      data.params.bookTypeCd = '330001';
      let result = await getEventList(data.params);
      data.list = result.data;
      root.$_localSort.set(data.list);
      data.count = result.data.length;
      searchValue.value = _.cloneDeep(data.list);
    }

    const insertFileName = (e) =>{
       var input = e.target;
       fileName.value = input.files[0].name;
       uploadImageFileValue.value = input.files[0];
       uploadImageFile.value = '';
      
     if (input.files && input.files[0])
      { 
        var reader = new FileReader();
          reader.onload = (e) => {          
             uploadImageFile.value = e.target.result; 
          }
          reader.readAsDataURL(input.files[0]);
      }
    }
    const saveDetail = () =>{
      data.params.mode = "detail";
      data.row.content = '';
      data.row.seq = null;
      Keyword.text = '';
      // await nextTick();
      data.row.startDt = '';
      data.row.endDt = '';
      data.row.announceDt = '';
      datetime_startDt.value.clearDate()
      datetime_endDt.value.clearDate()
      datetime_announceDt.value.clearDate()

      fileRemove();
    }
    
    const changeDate = (type) =>{
       let _temp = type == 'now' ? data.row.startDt : data.row.endDt;

       if(type == 'now'){
         if(Datedata.startDtChk == true){
           data.row.startDt = moment().format("yyyy-MM-DD HH:mm");
           Datedata.startDt = _.cloneDeep(_temp);
         }
         else{
           data.row.startDt = Datedata.startDt;
         }
       }else{
         if(Datedata.endDtChk == true){
          data.row.endDt = '9998-12-31 23:59';
          Datedata.endDt =  _.cloneDeep(_temp);
         }
         else{
          if (!Datedata.endDt || Datedata.endDt.startsWith('9')) {
            data.row.endDt = data.row.startDt ? moment(data.row.startDt, 'yyyy-MM-DD HH:mm').add(1, 'months').format("yyyy-MM-DD HH:mm") : moment().add(1, 'months').format("yyyy-MM-DD HH:mm");
          } else {
            data.row.endDt = Datedata.endDt;
          }
         }
       }
    }

    const OptionRefresh = async(item)=>{
      searchOptionsAll.value = [];
      searchOptions.value = [];

      let result = await getBoardCatList('01');
        searchOptionsAll.value.push({
          value : 0,
          text  : '전체',
        });
      if(result.data){
        result.data.map((row,i) => {
          searchOptionsAll.value.push({
            value : i,
            text  : row.categoryName,
          })
          searchOptions.value.push({
            value : i,
            text  : row.categoryName,
          })
        });
      }
    }
      const downloadAs = () => {
      const url = data.row.thumbnailUrl;
      const name = data.row.thumbnailName;
//        let fullUrl = aws_cdn_path + url;
        Axios.get(url, {
        headers: {
          "Content-Type": "application/octet-stream"
        },
        responseType: "blob"
      })
        .then(response => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(response.data);
          a.href = url;
          a.download = name;
          a.click();
        })
        .catch(err => {
          console.log("error", err);
        });
    };

    const fileRemove = ()=>{
      fileName.value = '';
      uploadImageFile.value = null;
      uploadImageFileValue.value = null;

      Datedata.startDtChk=false;
      Datedata.endDtChk=false;
      data.row.thumbnailUrl = null;
    }

    const showBottom = (toType, isToggle)=> {
      const curType = bottomType.value;
      if (isToggle) {
        bottomType.value = curType == BottomType.None ? toType : (curType == toType ? BottomType.None : toType);
      } else {
        bottomType.value = toType;
      }
    }

    onMounted(loadData)

    return{
      jodit_config,
      datetime_startDt,
      datetime_endDt,
      datetime_announceDt,
      searchText,
      searchValue,
      searchShowValue,
      selectedContSeq,
      uploadImageFile,
      fileName,
      insertFileName,
      searchOptionsYn,
      dataObject,
      _dataObject,
      data,
      Datedata,
      saveDetail,
      changeDate,
      OptionRefresh,
      fileRemove,
      uploadImageFileValue,
      downloadAs,
      BottomType,
      bottomType,
      showBottom,
      ...methods(),
      dataAction: new TableActionClass(data),
      localSort:root.$_localSort
    }
  },
}

function methods() {
  var context = {};
  context["getEventList"] = getEventList;
  context["getEventDetail"] = getEventDetail;
  context["saveEvent"] = saveEvent;
  context["saveEventPrize"] = saveEventPrize;
  context["deleteEvent"] = deleteEvent;
  context["deleteEventPrize"] = deleteEventPrize;

   // 목록
  async function search() {
    let _params = this.data.params;
    await this.dataAction.execute("getEventList",context,_params);
    this.fileRemove();
  }

  // 상세
  async function edit(_seq){
    let _params = {
      seq: _seq
    }
    let noticeInfo = await this.dataAction.execute("getEventDetail",context, _params);
    this.uploadImageFile = noticeInfo.data.thumbnailUrl;
    if(this.uploadImageFile !=null){
      this.uploadImageFileValue = '값있음';
    }
    this.fileName = noticeInfo.data.thumbnailName;
    //this.annNotice = true;
    if (this.data.row.endDt && this.data.row.endDt.startsWith('9')) {
      this.Datedata.endDtChk = true; // 영구
    }
  }

  function invalidReplayCheckBox(me) {
    const inval = me.data.row.replyYn=='Y'
                  && me.data.row.replyTeacherUseYn!='Y'
                  && me.data.row.replyTutorUseYn!='Y'
                  && me.data.row.replyStudentUseYn!='Y'
                  && me.data.row.replyParentsUseYn!='Y';
    console.log('invalidReplayCheckBox', inval);
    return inval;
  }

   // 저장
  async function save(type) { 
    let saveTitle =  this.data.row.seq==null?'저장' : '수정';
    if (type==this.BottomType.None) {
       if(!this.data.row.content || this.data.row.content.length < 2){
            alert("내용을 입력해주세요.");
       } else if(this.uploadImageFileValue == null){
            alert("썸네일을 등록해주세요.");
       } else if(invalidReplayCheckBox(this)){
            alert("댓글가능한 이벤트입니다. 댓글허용 회원유형을 선택해주세요.");
       } else {
          const isValid = await this.$validator.validateAll();
          if (!isValid) {
            alert('필수 입력 항목을 확인해주세요.');
            return false;
          }

          if (!confirm("내용을 "+saveTitle+" 하시겠습니까?")) {
            // 취소(아니오) 버튼 클릭 시 이벤트
            return false;
          }
          else{
            // 확인(예) 버튼 클릭 시 이벤트
            var formData = new FormData();
            
            if(this.data.row.seq !=null){
                formData.append("seq", this.data.row.seq);
                formData.append("title", this.data.row.title);
                formData.append("description", this.data.row.description);
                formData.append("content", this.data.row.content);
                formData.append("replyYn", !this.data.row.replyYn ? 'N' : this.data.row.replyYn);
                formData.append("replyAttachYn", !this.data.row.replyAttachYn ? 'N' : this.data.row.replyAttachYn);

                formData.append("readingTeacherUseYn", this.data.row.readingTeacherUseYn == null ? 'N' : this.data.row.readingTeacherUseYn);
                formData.append("readingTutorUseYn", this.data.row.readingTutorUseYn == null ? 'N' : this.data.row.readingTutorUseYn);
                formData.append("readingStudentUseYn", this.data.row.readingStudentUseYn == null ? 'N' : this.data.row.readingStudentUseYn);
                formData.append("readingParentsUseYn", this.data.row.readingParentsUseYn == null ? 'N' : this.data.row.readingParentsUseYn);

                formData.append("replyTeacherUseYn", this.data.row.replyTeacherUseYn == null ? 'N' : this.data.row.replyTeacherUseYn);
                formData.append("replyTutorUseYn", this.data.row.replyTutorUseYn == null ? 'N' : this.data.row.replyTutorUseYn);
                formData.append("replyStudentUseYn", this.data.row.replyStudentUseYn == null ? 'N' : this.data.row.replyStudentUseYn);
                formData.append("replyParentsUseYn", this.data.row.replyParentsUseYn == null ? 'N' : this.data.row.replyParentsUseYn);

                formData.append("endDt", moment(this.data.row.endDt, 'YYYY-MM-DD HH:mm').format("yyyy-MM-DD HH:mm:ss"));
                formData.append("startDt", moment(this.data.row.startDt, 'YYYY-MM-DD HH:mm').format("yyyy-MM-DD HH:mm:ss"));

                formData.append("mfile", this.uploadImageFileValue == null ? '' : this.uploadImageFileValue);

            }else{
                formData.append("title", this.data.row.title);
                formData.append("description", this.data.row.description);
                formData.append("content", this.data.row.content);
                formData.append("replyYn", !this.data.row.replyYn ? 'N' : this.data.row.replyYn);
                formData.append("replyAttachYn", !this.data.row.replyAttachYn ? 'N' : this.data.row.replyAttachYn);

                formData.append("readingTeacherUseYn", this.data.row.readingTeacherUseYn == null ? 'N' : this.data.row.readingTeacherUseYn);
                formData.append("readingTutorUseYn", this.data.row.readingTutorUseYn == null ? 'N' : this.data.row.readingTutorUseYn);
                formData.append("readingStudentUseYn", this.data.row.readingStudentUseYn == null ? 'N' : this.data.row.readingStudentUseYn);
                formData.append("readingParentsUseYn", this.data.row.readingParentsUseYn == null ? 'N' : this.data.row.readingParentsUseYn);

                formData.append("replyTeacherUseYn", this.data.row.replyTeacherUseYn == null ? 'N' : this.data.row.replyTeacherUseYn);
                formData.append("replyTutorUseYn", this.data.row.replyTutorUseYn == null ? 'N' : this.data.row.replyTutorUseYn);
                formData.append("replyStudentUseYn", this.data.row.replyStudentUseYn == null ? 'N' : this.data.row.replyStudentUseYn);
                formData.append("replyParentsUseYn", this.data.row.replyParentsUseYn == null ? 'N' : this.data.row.replyParentsUseYn);

                formData.append("endDt", moment(this.data.row.endDt, 'YYYY-MM-DD HH:mm').format("yyyy-MM-DD HH:mm:ss"));
                formData.append("startDt", moment(this.data.row.startDt, 'YYYY-MM-DD HH:mm').format("yyyy-MM-DD HH:mm:ss"));

                formData.append("mfile", this.uploadImageFileValue == null ? '' : this.uploadImageFileValue);
            }
            let result = await saveEvent(formData).then((result) => {
              if(result.data){
                console.log('save success', result.data);
                this.data.row.seq = result.data;
                alert(saveTitle+'이 완료되었습니다.');
              }
            }); 
          }
      }
    } else if (type==this.BottomType.AnnNotice){
      const action = this.data.row.announceYn == 'Y' ? '수정' : '등록';
      if (!confirm(`당첨자 발표를 ${action}하시겠습니까?`)) {
        return false;
      }
      let params = {
        seq : this.data.row.seq,
        announceContent : this.data.row.announceContent,
        announceDt: moment(this.data.row.announceDt, 'YYYY-MM-DD HH:mm').format("yyyy-MM-DD HH:mm:ss"),
      }
      const result = await saveEventPrize(params);
      if (result.data) {
        alert(`당첨자 발표가 ${action}되었습니다.`);
        this.data.row.announceYn = 'Y';
      }
    } else if (type==this.BottomType.ReplyNotice) {
      const replySeq = this.data.row.replySeq;
      const action = replySeq ? '수정' : '등록';
      if (!confirm(`댓글 공지를 ${action}하시겠습니까?`)) {
        return false;
      }
      
      const params = {
        content : this.data.row.replyNotice
      }
      if (replySeq) {
        params.seq = replySeq
      } else {
        params.eventSeq = this.data.row.seq;
      }
      const result = await saveReplyNotice(params);
      alert(`댓글 공지가 ${action}되었습니다.`);
      if (!replySeq) {
        this.data.row.replySeq = result.data;
      }
    }
  }

  async function remove(delType) {
    if (delType == this.BottomType.None) {
      if (!confirm('이벤트를 삭제하시겠습니까?')) {
        return false;
      }
      const params = {
        seq : this.data.row.seq,
      }
      const result = await deleteEvent(params);
      if(result.data){
        alert('삭제가 완료되었습니다.');
        this.bottomType=this.BottomType.None;
        this.search(); // 목록가기
      }
    } else if (delType == this.BottomType.AnnNotice) {
      if (!confirm('당첨자 발표를 삭제하시겠습니까?')) {
        return false;
      }
      const params = {
        seq : this.data.row.seq,
      }
      const result = await deleteEventPrize(params);
      if(result.data){
        alert('삭제가 완료되었습니다.');
        this.data.row.announceYn = 'N';
        this.data.row.announceDt = null;
        this.data.row.announceContent = null;
      }
    } else if (delType == this.BottomType.ReplyNotice) {
      if (!confirm('댓글 공지를 삭제하시겠습니까?')) {
        return false;
      }
      const params = {
        seq : this.data.row.replySeq
      }
      const result = await deleteReplyNotice(params);
      if(result.data){
        alert('삭제가 완료되었습니다.');
        this.data.row.replySeq = 0;
        this.data.row.replyNotice = null;
      }
    }
  }

  // 초기화
  async function reset(){
    this.data.params.mode="list";
  }

  return {
    search,
    remove,
    edit,
    reset,
    save,
  }
}

</script>
